import { Suspense, type ReactNode } from 'react';
import { useSnackbars } from '@customerio/pluma-components/react';
import { AppErrorBoundary } from '@/components/app-error-boundary';

type LazyPanelBoundaryProps = {
  resetKey: unknown;
  onLoadError: () => void;
  fallback?: ReactNode;
  children: ReactNode;
};

export function LazyPanelBoundary({ resetKey, onLoadError, fallback = null, children }: LazyPanelBoundaryProps) {
  const snackbars = useSnackbars();

  return (
    <AppErrorBoundary
      fallback={null}
      resetKeys={[resetKey]}
      onError={() => {
        snackbars.create({
          variant: 'critical',
          id: 'purchase.lazyPanel.loadError',
          message: "This panel couldn't be loaded. Refresh the page and try again.",
        });
        onLoadError();
      }}
    >
      <Suspense fallback={fallback}>{children}</Suspense>
    </AppErrorBoundary>
  );
}
